import { ChangeEvent, useEffect, useRef, useState } from "react";
import { Input, InputProps } from "reactstrap";
import useValueList, { getValueLabel } from "../../../hook/useValueList";
import { IOption } from "../../../types/common";
import { trimToEmpty } from "../../../utils/commons";
import SearchInput from "./search-input";

interface CityInputProps extends InputProps {
  innerName: string;
  onConfirm?: (id?: number) => void;
}

const CityInput = (props: CityInputProps) => {
  const { innerName, onConfirm, name, value, placeholder, invalid, onChange, ...inputProps } = props;

  const isControlled = 'value' in props;

  const [cities] = useValueList('CITY');

  const [options, setOptions] = useState<IOption[]>([]);
  const [filteredOptions, setFilteredOptions] = useState<IOption[]>([]);

  const [idValue, setIdValue] = useState('');
  const [textValue, setTextValue] = useState('');

  const idInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    setOptions(cities.map(item => (
      {
        id: item.id,
        label: item.label
      }
    )));

    if (props.value) {
      setIdValue(props.value ? props.value.toString() : '');
    }
  }, [cities, props.value]);

  useEffect(() => {
    if (idValue && +idValue > 0) {
      setTextValue(getValueLabel(cities, +idValue) ?? '');
    }

    if (!isControlled && idInputRef.current) {
      idInputRef.current.value = idValue ?? '';
    }

    onConfirm?.(+idValue);
  }, [cities, idValue]);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setTextValue(value);
    setIdValue('0');

    if (trimToEmpty(value).length === 0) {
      setIdValue('');
    } else {
      const city = cities.find(item => item.label.toLowerCase() === value.trim().toLowerCase());
      if (city) {
        event.target.value = city.label;
        setIdValue(city.id.toString());
      }
    }

    onChange?.(event);
  };

  const handleSearch = (str: string) =>
    setFilteredOptions(
      options?.filter(c => c.label.toLowerCase().startsWith(str.toLowerCase()))
    );

  const handleConfirm = (option: IOption) => setIdValue(option.id.toString());

  return (isControlled
    ? <>
      <SearchInput auto
        name={name}
        maxLength={100}
        placeholder={placeholder}
        value={textValue}
        onChange={handleChange}
        invalid={invalid}
        options={filteredOptions}
        onSearch={handleSearch}
        onConfirm={handleConfirm} />
      <Input {...inputProps} className="d-none"
        type="number"
        name={innerName}
        value={idValue}
        onChange={() => { }} />
    </>
    : <>
      <SearchInput auto
        name={name}
        maxLength={100}
        placeholder={placeholder}
        onChange={handleChange}
        invalid={invalid}
        options={filteredOptions}
        onSearch={handleSearch}
        onConfirm={handleConfirm} />
      <Input {...inputProps} className="d-none"
        type="number"
        name={innerName}
        innerRef={idInputRef} />
    </>
  );
};

export default CityInput;
